export default "__VITE_ASSET__0ffa6b27__"